import React from 'react';
import { usePlanningBreachStore } from '../../../../hooks/usePlanningBreachStore';

export const SelectedLocationTextContent: React.FC = () => {
  const {
    data: { issueLocationData },
  } = usePlanningBreachStore();

  const fullAddress = issueLocationData?.full_address || '';
  const asset: any = issueLocationData?.asset;

  const centralAssetId = (asset && asset.Refval) || undefined;

  if (!fullAddress) return null;

  return (
    <div
      className="text-bodyXl mt-4 flex flex-col gap-[1.25rem]"
      data-testid="planning-breach-selected-location"
    >
      <p className="font-semibold text-black">Issue location</p>
      <p className="font-normal text-black">{fullAddress}</p>

      {centralAssetId && (
        <p className="font-normal text-black">{`Listed building: ${String(centralAssetId)}`}</p>
      )}
    </div>
  );
};
